export default async function getUserId() {
  return localStorage.getItem("forever-kite-userId");
}
